'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contextTypes = exports.DOCUMENT_LOADED = exports.IMAGES_LOADED = exports.REMOVE_IMAGE_REF = exports.APPEND_IMAGE_REF = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _contextTypes;

exports.default = SimpleImgProvider;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _initSimpleImg = require('./initSimpleImg');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var APPEND_IMAGE_REF = exports.APPEND_IMAGE_REF = '__ProgresssiveImagesAppendImageRef__';
var REMOVE_IMAGE_REF = exports.REMOVE_IMAGE_REF = '__ProgresssiveImagesRemoveImageRef__';
var IMAGES_LOADED = exports.IMAGES_LOADED = '__ProgresssiveImagesLoaded__';
var DOCUMENT_LOADED = exports.DOCUMENT_LOADED = '__DocumentLoaded__';
var contextTypes = exports.contextTypes = (_contextTypes = {}, _defineProperty(_contextTypes, APPEND_IMAGE_REF, _propTypes2.default.func), _defineProperty(_contextTypes, REMOVE_IMAGE_REF, _propTypes2.default.func), _defineProperty(_contextTypes, IMAGES_LOADED, _propTypes2.default.object), _defineProperty(_contextTypes, DOCUMENT_LOADED, _propTypes2.default.bool), _contextTypes);

function SimpleImgProvider(WrappedComponent) {
  var _class, _temp2;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _initSimpleImg.defaultConfig;

  return _temp2 = _class = function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        mountedImages: new Set(),
        isDocumentLoad: false
      }, _this.appendImageRef = function (image) {
        return _this.observer && _this.observer.observe(image);
      }, _this.removeImageRef = function (image) {
        // $FlowIgnoreLine:
        _this.observer.unobserve(image);
        _this.setState(function (_ref2) {
          var mountedImages = _ref2.mountedImages;

          mountedImages.delete(image);
          return {
            mountedImages: mountedImages
          };
        });
      }, _this.appendImgLoadingRef = function (image) {
        _this.imageLoadRefs.add(image);
      }, _this.removeImgLoadingRef = function (image) {
        _this.imageLoadRefs.delete(image);
      }, _this.observer = {}, _this.imageLoadRefs = new Set(), _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(_class, [{
      key: 'getChildContext',
      value: function getChildContext() {
        var _ref3;

        return _ref3 = {}, _defineProperty(_ref3, APPEND_IMAGE_REF, this.appendImageRef), _defineProperty(_ref3, REMOVE_IMAGE_REF, this.removeImageRef), _defineProperty(_ref3, IMAGES_LOADED, this.state.mountedImages), _defineProperty(_ref3, DOCUMENT_LOADED, this.state.isDocumentLoad), _ref3;
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        /* eslint-disable */
        window.addEventListener('load', function () {
          _this2.observer = _initSimpleImg.observerStart.call(_this2, config);
          _this2.setState({
            isDocumentLoad: true
          });
        });

        if (document.readyState === 'complete') {
          this.observer = _initSimpleImg.observerStart.call(this, config);
        }
        /* eslint-enable */
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.imageLoadRefs.forEach(function (image) {
          // cancel all loading images;
          image.src = ''; // eslint-disable-line no-param-reassign
        });
        this.imageLoadRefs.clear();
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(WrappedComponent, this.props);
      }
    }]);

    return _class;
  }(_react2.default.Component), _class.childContextTypes = contextTypes, _class.displayName = 'SimpleImgProvider(' + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ')', _temp2;
}